'use strict';

const flyout = require('./flyout'),
    page = require('./page'),
    register = require('./pages/registration'),
    getQueryParameter = require('./modules/util/getQueryParameter'),
    isMobile = require('./modules/util/isMobile'),
    isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth'),
    validator = require('./validator'),
    ajax = require('./modules/ajax'),
    scrollHelper = require('./modules/helpers/scroll'),
    isSmallView = require('./modules/helpers/isSmallView'),
    toaster = require('./toaster'),
    ritualsFormHelper = require('./rituals-form-helper'),
    loseGiftGuestWarning = require('./loseGiftGuestWarning'),
    dialog = require('./dialog'),
    gtm = require('./modules/google').tagManager,
    recaptchaConfig = require('./recaptchaConfig'),
    damHelper = require('./dam/dam-helper');

const login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        const pathParams = window.location.search;
        if (pathParams.includes('code')) {
            const dialogText = $('.js-magic-link-email').val();
            openDialog(dialogText);
        }

        if (pathParams.includes('redirected')) {
            const dialogText = $('.js-label-invalid-oobcode').val();
            const dialogButton = $('.js-button-invalid-oobcode').val();
            openDialog(dialogText, dialogButton);
        }

        ritualsFormHelper.init();
        toaster.init();

        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function () {
            $('#OAuthProvider').val(this.id);
        });

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });

        bindForProfileCheck();
        bindSetPasswordClick();
        bindResetPasswordClick();
        bindLoginFormSubmit();
        showVerificationMessage();
        bindCompleteFormSubmit();
        initializeNextLoginStep();
        initializeRecaptcha();
        bindDynamicPasswordCheck();

        const guestLoginBtn = $('div.js-guest-button button:first-child');
        guestLoginBtn.on('click', onGuestLoginBtnDown);
        guestLoginBtn.on('keydown', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                onGuestLoginBtnDown();
            }
        });

        guestLoginBtn.focusout(function () {
            $('input[id^="dwfrm_login_password"]').removeData('prevent-automatic-validation');
        });

        const forgotPasswordLink = $('.js-password-reset-link');
        forgotPasswordLink.on('click', onforgotPasswordLinkDown);
        forgotPasswordLink.mousedown(onforgotPasswordLinkDown);
        forgotPasswordLink.on('keydown', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                onforgotPasswordLinkDown();
            }
        });

        $(document).on('click', '.btn-register-submit', function () {
            const errorMessage = $('.error-text:first').text();
            if (errorMessage) {
                gtm.pushDataLayerEvent({
                    event: 'signup',
                    error_type: null,
                    error_message: errorMessage.toLowerCase(),
                    error_code: null,
                    content_name: 'sign up'
                });
            }
            setTimeout(function() {
                $('.error-text').each(function() {
                    if ($(this).is('.input-checkbox.js-validator-error')) {
                        gtm.pushDataLayerEvent({
                            event: 'form_field_error',
                            error_type: 'form_field_error',
                            error_message: 'Terms & condition are not accepted',
                            error_code: null,
                            content_name: 'register page'
                        });
                    }
                });
            }, 500);
        });

        forgotPasswordLink.focusout(function () {
            $('input[id^="dwfrm_login_password"]').removeData('prevent-automatic-validation');
        });

        $('.js-close-flyout').on('keydown.resetpassword', function (e) {
            if (e.which == 9 && e.shiftKey) {
                const $lastButtonFlyout = flyout.def.$genericFlyout.find('.js-homepage-link');
                if (!$lastButtonFlyout.length) {
                    return;
                }
                e.preventDefault();
                flyout.def.$genericFlyout.find('.js-homepage-link').focus();
            }
        });

        $('.js-password-reset-dialog').on('click', function (e) {
            e.preventDefault();
            flyout.load({
                url: $(e.target).attr('href'),
                open: function () {
                    validator.init();
                }
            });
            $(this).addClass('js-flyout-opened');
        });

        //Back button for Account and Reset password page
        $(document).on('click', '.js-account-back', function () {
            window.history.back();
        });

        //Back button on mobile for Checkout login
        $(document).on('click', '.js-login-back', function () {
            window.history.back();
        });

        $('.js-reset-password-confirmation')
            .find('.js-reset-password-close, .js-continue-password-reset')
            .attr('tabindex', '-1');

        //close the reset password popup (toaster on mobile)
        $(document).on(
            'click touchstart',
            '.js-reset-password-close, .js-continue-password-reset, .js-modal-overlay',
            function () {
                $('.js-reset-password-confirmation').removeClass('open');
                $('.js-modal-overlay').fadeOut();
                $('.js-reset-password-confirmation')
                    .find('.js-reset-password-close, .js-continue-password-reset')
                    .attr('tabindex', '-1');
                $('.js-password-reset-button').focus();
            }
        );

        $('.js-new-password-confirmation')
            .find('.js-new-password-close, .js-new-password-reset')
            .attr('tabindex', '-1');

        //close the set new password popup (toaster on mobile)
        $(document).on(
            'click touchstart',
            '.js-new-password-close, .js-new-password-reset, .js-modal-overlay',
            function () {
                $('.js-new-password-confirmation').removeClass('open');
                $('.js-modal-overlay').fadeOut();
                $('.js-new-password-confirmation')
                    .find('.js-new-password-close, .js-new-password-reset')
                    .attr('tabindex', '-1');
            }
        );

        $('body').on('click', '.js-password-reset-link', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const emailField = $('input[id^="dwfrm_login_username"]');
            let emailVal;

            if (emailField.length) {
                emailVal = emailField.val().trim();
            }

            if (!emailVal) {
                window.location.href = $(this).attr('href');
            }
            const passFrm = $('#dwfrm_requestpassword');
            passFrm.find('input.js-emailtopass').val(emailVal);
            passFrm.submit();
        });

        $('.js-password-reset-link').on('keydown', function (e) {
            const key = e.which;
            if (key == 13) {
                $(this).click();
            }
        });

        //toggle password visibility
        $(document).on('click', '.js-toggle-password-visibility', function (e) {
            e.preventDefault();
            const $this = $(this);
            $this.toggleClass('visible');

            if ($this.hasClass('visible')) {
                e.preventDefault();
                $this.prevAll('.input-text.passwordcheck, .inputfield-text').attr('type', 'text');
                return;
            }

            $this.prevAll('.input-text.passwordcheck, .inputfield-text').attr('type', 'password');
        });

        const welcomeBack = getQueryParameter(window.location.href, 'welcomeBack');
        if (welcomeBack) {
            let welcomeBackText = $('.js-new-password-confirmation span.text-container').text();
            welcomeBackText = welcomeBackText.replace('{0}', welcomeBack);
            $('.js-new-password-confirmation span.text-container').text(welcomeBackText);

            if (!$('.pt_account_loggedin').length) {
                $('.js-new-password-confirmation').addClass('open');
                $('.js-modal-overlay').fadeIn();
                $('.js-new-password-confirmation').find('.js-new-password-reset').focus();
                $('.js-new-password-confirmation')
                    .find('.js-new-password-close, .js-new-password-reset')
                    .attr('tabindex', '0');
            }

            $('.js-new-password-reset').on('keydown', function (e) {
                if (e.which == 9) {
                    e.preventDefault();
                    $('.js-new-password-close').focus();
                }
            });

            $('.js-new-password-close').on('keydown', function (e) {
                if (e.which == 9) {
                    e.preventDefault();
                    $('.js-new-password-reset').focus();
                }
            });

            $(document).on('keydown', function (e) {
                if (e.which == 27 && $('.js-new-password-confirmation').hasClass('open')) {
                    e.preventDefault();
                    $('.js-new-password-confirmation').removeClass('open');
                    $('.js-modal-overlay').fadeOut();
                    $('.js-new-password-confirmation')
                        .find('.js-new-password-close, .js-new-password-reset')
                        .attr('tabindex', '-1');
                    $('.js-skip-to-content').focus();
                }
            });
        }

        $(document).on('click', '#btn-checkout-guest', function () {
            const guest = document.getElementById('checkoutAsGuest');
            if (guest) {
                guest.value = 'true';
            }
        });

        $(document).on('click', '#btn-login', function () {
            const guest = document.getElementById('checkoutAsGuest');
            if (guest) {
                guest.value = 'false';
            }
        });

        $(document).on('click', '#btn-checkout-register', function () {
            $(this).addClass('button-loading');
            $(this).find('.js-spinner-general').addClass('spinner-visible');
        });

        //data layer event for errors on username input in login form
        $('input[id^="dwfrm_login_username"]').on('blur', function() {
            if ($(this).hasClass('js-validator-error')) {
                gtm.pushDataLayerEvent({
                    event: 'form_field_error',
                    error_type: 'form_field_error',
                    error_message: 'wrong email, please enter a valid value',
                    error_code: null,
                    content_name: 'login page'
                });
            }
        });
    },
    hideOverlay: hideOverlay
};

const openDialog = function (dialogText, dialogButton) {
    if (!dialogText) {
        return;
    }

    if (!dialogButton) {
        dialogButton = window.Resources.CONTINUE;
    }

    window.eventBus.$emit('shouldOpenModal', {
        paragraphs: [
            {
                text: dialogText
            }
        ],
        buttons: [
            {
                type: 'btn btn--secondary',
                label: dialogButton,
                shouldCloseModal: true
            }
        ],
        ctaHolder: {
            hideOnMobileAndTablet: false
        },
        row: {
            class: 'center-align'
        },
        closeElement: {
            shouldCloseModal: true
        },
        shouldModalCloseOnMobile: false,
        modalCustomId: 'LoginPage'
    });
};

const onGuestLoginBtnDown = function () {
    $('input[id^="dwfrm_login_password"]').data('prevent-automatic-validation', true);
    $('span[id^="dwfrm_login_password"]').addClass('hide').removeAttr('style');
    $('input[id^="dwfrm_login_password"]').removeClass('js-validator-error error');
};

const onforgotPasswordLinkDown = function () {
    $('input[id^="dwfrm_login_password"]').data('prevent-automatic-validation', true);
    $('span[id^="dwfrm_login_password"]').addClass('hide').removeAttr('style');
    $('input[id^="dwfrm_login_password"]').removeClass('js-validator-error error');
};

const bindSetPasswordClick = function () {
    $('body').on('click.resetpassword', '[name$="_resetpassword_send"]', function () {
        const $submit = $(this);
        const $NewPasswordForm = $submit.parents('[name$="NewPasswordForm"]');
        if (!$NewPasswordForm.valid()) {
            return;
        }
        $submit.addClass('btn--disabled').addClass('button-loading');
        $submit.find('.js-spinner-general').addClass('spinner-visible');
    });
};

const bindResetPasswordClick = function () {
    $('body').on('click.resetpassword', '[name$="_requestpassword_send"]', function (e) {
        const $submit = $(this);
        const $requestPasswordForm = $submit.parents('[name$="_requestpassword"]');
        e.preventDefault();
        if (!$requestPasswordForm.valid()) {
            return;
        }
        $submit.addClass('btn--disabled').addClass('button-loading');
        $submit.find('.js-spinner-general').addClass('spinner-visible');

        if (executeRecapthcaForForm($requestPasswordForm)) {
            e.preventDefault();
            return false; // form will be submitted in the handler function registered in recaptcha for 'recaptchaContainerId' div
        }

        const options = {
            form: $requestPasswordForm,
            triggeredAction: $submit.attr('name'),
            handleCsrfMismatch: function () {
                page.redirect(Urls.csrffailed);
            },
            handleJson: function (response) {
                const emailField = $('#dwfrm_requestpassword_email');

                if (response.showRecaptcha) {
                    initializeInvisibleRecaptcha($requestPasswordForm, 'resetpassword--recaptcha-container');
                    $('#resetpassword--recaptcha-container').removeClass(
                        recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS
                    ); // from now on use recaptcha on page
                    $submit.removeClass('btn--disabled').removeClass('button-loading');
                    $submit.find('.js-spinner-general').removeClass('spinner-visible');
                }

                if (response.errorMessage) {
                    const validator = $requestPasswordForm.validate();

                    validator.showErrors({
                        dwfrm_requestpassword_email: response.errorMessage
                    });

                    if (!response.showRecaptcha) {
                        $submit.removeClass('btn--disabled').removeClass('button-loading');
                        $submit.find('.js-spinner-general').removeClass('spinner-visible');
                    }
                }

                emailField.focus();
            },
            callback: function (response) {
                $submit.removeClass('btn--disabled').removeClass('button-loading');
                $submit.find('.js-spinner-general').removeClass('spinner-visible');
                const $response = $(response);
                if (showResetPasswordError($response)) {
                    return;
                }

                // wrapping $response in a div because it a list of nodes for which selector can not be used
                if ($('<div>').append($response).find('.js-display-recaptcha').length) {
                    initializeInvisibleRecaptcha($requestPasswordForm, 'resetpassword--recaptcha-container');
                    $('#resetpassword--recaptcha-container').removeClass(
                        recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS
                    ); // from now on use recaptcha on page
                }

                const passwordConfirmationText = $(response).filter('.js-reset-password-email').val();

                openDialog(passwordConfirmationText);
            },
            handleError: function () {
                $('.js-flyout-content').html('<h1>' + Resources.SERVER_ERROR + '</h1>');
            }
        };
        ajax.postForm(options);
    });
};

const bindForProfileCheck = function () {
    const loginField = $('.js-profilecheck');
    if (!loginField.length) {
        return;
    }

    loginField.on('blur', function () {
        if (this.value.length > 0) {
            $.ajax({
                dataType: 'json',
                url: Urls.checkAccountStatus,
                data: 'login=' + this.value
            }).done(function (val) {
                if (val.result === 1) {
                    flyout.load({
                        url: Urls.friendlyPasswordReset + '&email=' + $('.js-profilecheck').val()
                    });
                }
            });
        }
    });
};

const bindLoginFormSubmit = function () {
    bindHistoryHandler();

    $(document).on('submit.ajaxflow', '#dwfrm_login.js-loginajax-form', function (e) {
        processLoginSubmit(this, e);
    });

    if (window.location.hash === '#choose') {
        const loginForm = $('#dwfrm_login.js-loginajax-form');
        const email = $('input[name$=customerEmail]').val();

        const emailField = $('input[id^="dwfrm_login_username"]');
        emailField.val(email);

        processLoginSubmit(loginForm, null);
    } else {
        $('.js-loginwrap').removeClass('hide');
    }
};

const processLoginSubmit = function (formElement, e) {
    const form = $(formElement);
    preventDefault(e);

    if (!form.valid()) {
        return;
    }

    const checkoutAsGuest =
        document.getElementById('checkoutAsGuest') && document.getElementById('checkoutAsGuest').value;
    const submitElements = form.find('button[type=submit]');

    let submit;
    if (checkoutAsGuest === 'true') {
        submit = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-checkout-guest';
        });
    } else {
        submit = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-login';
        });
    }

    submitElements.addClass('btn--disabled');
    submit.addClass('button-loading');
    submit.find('.js-spinner-general').addClass('spinner-visible');

    history.replaceState(
        {showElement: '.js-loginwrap', removeElement: '.js-ajaxflow'},
        'login-start',
        window.location.href
    );
    history.pushState({formToSubmit: '#dwfrm_login'}, null, window.location.href.split('#')[0] + '#');

    const options = {
        form: form,
        handleJson: handleExistingAccount,
        handleCsrfMismatch: handleLoginCsrfMismatch,
        triggeredAction: submit.attr('name'),
        callback: function (response) {
            if (checkoutAsGuest && response.redirectTo) {
                window.location.replace(response.redirectTo);
                return;
            }
            submitElements.removeClass('btn--disabled');
            submit.removeClass('button-loading');
            submit.find('.js-spinner-general').removeClass('spinner-visible');
            $('[data-page-name]').remove();
            $('.js-loginwrap').hide().after(response);

            initializeNextLoginStep();
        }
    };

    ajax.postForm(options);
};

const preventDefault = function (e) {
    if (e !== null && e !== 'undefined') {
        e.preventDefault();
    }
};

function initializeNextLoginStep() {
    let pageName;

    loseGiftGuestWarning.init();

    const formEl = $('[data-page-name]');

    if (formEl.length > 0) {
        formEl.find('input:not([type=hidden])').first().focus();
        validator.init();
        ritualsFormHelper.init();

        pageName = formEl.data('page-name');

        const imageHolder = formEl.find('.js-account-benefits-image-holder');
        if (imageHolder.length > 0) {
            damHelper.updateImages(imageHolder, true);
        }

        setTimeout(function () {
            const recaptchaContainerId = pageName + '--recaptcha-container';
            const $form = $('#' + recaptchaContainerId).parents('form');
            initializeInvisibleRecaptcha($form, recaptchaContainerId);
        }, 1000);
    }

    if (pageName === 'registration') {
        history.replaceState(
            {showElement: '.js-loginwrap', removeElement: '.js-ajaxflow'},
            'login-start',
            window.location.href
        );
        history.pushState({formToSubmit: '#dwfrm_login'}, null, window.location.href.split('#')[0] + '#');
        bindRegistrationFormSubmit();
        register.init();
        return;
    }

    if (pageName) {
        history.replaceState(
            {showElement: '.js-loginwrap', removeElement: '[data-page-name="' + pageName + '"]'},
            'login-start',
            window.location.href
        );
        history.pushState(
            {formToSubmit: '#dwfrm_login'},
            pageName,
            window.location.href.split('#')[0] + '#' + pageName
        );
    }

    if (isSmallView()) {
        $('html, body').scrollTop(0);
    }
}

function executeRecapthcaForForm(form) {
    const recaptchaContainerId = form.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR);
    // if there is recaptcha -> only submit the form once the recaptcha is validated (js-recaptchadone class is set on a form)
    if (
        !form.hasClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS) ||
        form.hasClass(recaptchaConfig.CONSTANTS.CHALLENGE_DONE_CLASS)
    ) {
        recaptchaConfig.removeChallengeDoneClass(recaptchaContainerId); // removes 'js-recaptchadone' class indicator
        return false;
    }

    const recaptchaContainer = form.find('#' + recaptchaContainerId);
    if (recaptchaContainer.length && !recaptchaContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS)) {
        recaptchaConfig.executeForContainer(recaptchaContainerId);
        return true; // form will be submitted in the handler function registered in recaptcha for 'recaptchaContainerId' div (recaptchaConfig.init call params)
    }

    return false;
}

const bindCompleteFormSubmit = function () {
    $('body')
        .off('submit', '#dwfrm_completeaccount.js-loginajax-form')
        .on('submit', '#dwfrm_completeaccount.js-loginajax-form', function (e) {
            const form = $(this);
            e.preventDefault();
            if (!form.valid()) {
                return;
            }

            const submitElements = form.find('button[type=submit]');
            const checkoutAsGuest =
                document.getElementById('checkoutAsGuest') && document.getElementById('checkoutAsGuest').value;

            let submit;
            if (checkoutAsGuest === 'true') {
                submit = submitElements.filter(function () {
                    return $(this).attr('id') === 'btn-checkout-guest';
                });
            } else {
                submit = submitElements.filter(function () {
                    return $(this).attr('id') === 'btn-login';
                });
            }

            submitElements.addClass('btn--disabled');
            submit.addClass('button-loading');
            submit.find('.js-spinner-general').addClass('spinner-visible');

            if (executeRecapthcaForForm(form)) {
                e.preventDefault();
                return false; // form will be submitted in the handler function registered for form in recaptcha for 'recaptchaContainerId' div
            }

            const options = {
                form: form,
                handleJson: handleCompleteResponse,
                handleCsrfMismatch: handleLoginCsrfMismatch,
                triggeredAction: submit.attr('name')
            };

            ajax.postForm(options);
        });
};

const bindRegistrationFormSubmit = function () {
    $('body').on('submit', '#RegistrationForm.js-loginajax-form', function (e) {
        const form = $(this);
        e.preventDefault();
        const submit = $(this).find('button[type=submit]');

        if (!form.valid()) {
            return;
        }
        submit.addClass('btn--disabled').addClass('button-loading');
        submit.find('.js-spinner-general').addClass('spinner-visible');

        if (executeRecapthcaForForm(form)) {
            e.preventDefault();
            return false; // form will be submitted in the handler function registered in recaptcha for 'recaptchaContainerId' div
        }

        const options = {
            form: form,
            handleJson: handleRegistrationResponse,
            handleCsrfMismatch: login.handleLoginCsrfMismatch,
            triggeredAction: submit.attr('name')
        };

        ajax.postForm(options);
    });
};

function initializeRecaptcha() {
    const recaptchaLoginFormContainer = $('#recaptcha-container-login');
    if (
        recaptchaLoginFormContainer &&
        !recaptchaLoginFormContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS)
    ) {
        initializeInvisibleRecaptcha($('#dwfrm_login'), 'recaptcha-container-login');
    }

    const recaptchaResetPasswordFormContainer = $('#resetpassword--recaptcha-container');
    if (
        recaptchaResetPasswordFormContainer &&
        !recaptchaResetPasswordFormContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS)
    ) {
        initializeInvisibleRecaptcha($('#PasswordResetForm'), 'resetpassword--recaptcha-container');
    }
}

function initializeInvisibleRecaptcha(form, containerId) {
    const recaptchaDefinitions = [
        recaptchaConfig.buildContainerDefinition(form, containerId, recaptchaConfig.defaultVerifyHandler)
    ];
    recaptchaConfig.init(recaptchaDefinitions);
    form.addClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS);
    form.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR, containerId);
}

const handleExistingAccount = function (response) {
    $('[data-page-name]').remove();
    const form = $('#dwfrm_login');
    const submitElements = form.find('button[type=submit]');

    const checkoutAsGuest =
        document.getElementById('checkoutAsGuest') && document.getElementById('checkoutAsGuest').value;
    let button;
    if (checkoutAsGuest === 'true') {
        button = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-checkout-guest';
        });
    } else {
        button = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-login';
        });
    }

    const isOnboardingView = $('.js-onboarding-view').length > 0;
    if (isOnboardingView) {
        storeOnboardingLogin();
    }

    if (response.redirectTo) {
        window.location.replace(response.redirectTo);
        return;
    }

    if (response.showPasswordField) {
        form.attr('action', response.continueURL);

        if (!response.ajaxFlow) {
            form.addClass('js-postback');
        }

        const $spinner = $('.js-spinner-general', button);

        button.attr('value', response.buttonLabel);
        button.attr('name', response.buttonHtmlName);
        button.text(response.buttonLabel);
        button.append($spinner);
        $('.js-guest-button').addClass('hidden');
        $('.js-guest-div').addClass('hidden');
        $('.js-page-layout-left-subtitle').text(response.subtitle);
        const elementsToSlide = response.showRecaptcha ? form.find('.hide') : form.find('.js-slidedown.hide');
        loseGiftGuestWarning.init();
        elementsToSlide.slideDown(function () {
            const passwordField = form.find('input[type=password]');
            passwordField.removeAttr('disabled');
            elementsToSlide.removeClass('hide');
            elementsToSlide.find('label, .js-toggle-password-visibility').removeClass('label-disabled');
            if (response.showRecaptcha) {
                initializeInvisibleRecaptcha(form, 'recaptcha-container-login');
            }
            button.removeClass('btn--disabled').removeClass('button-loading');
            button.find('.js-spinner-general').removeClass('spinner-visible');
            passwordField.focus();
        });

        if (response.ajaxFlow) {
            return;
        }

        $('#dwfrm_login.js-loginajax-form').removeClass('js-loginajax-form');
        return;
    }

    if (response.errorHtml) {
        const existingMessage = form.find('.error-form');
        if (!existingMessage.length) {
            form.prepend(response.errorHtml);
        }
        existingMessage.hide().slideDown();
    }

    if (response.showRecaptcha) {
        initializeInvisibleRecaptcha(form, 'recaptcha-container-login');
        button.removeClass('btn--disabled');
        return;
    }

    if (response.validCredentials) {
        handleSuccessfullyLogin(response.showGwpWelcomeMessage);
    }

    submitElements.removeClass('btn--disabled');
    button.removeClass('button-loading');
    button.find('.js-spinner-general').removeClass('spinner-visible');
};

const handleCompleteResponse = function (response) {
    return handleJSONResponse(response, '#dwfrm_completeaccount');
};

const handleRegistrationResponse = function (response) {
    return handleJSONResponse(response, '#RegistrationForm');
};

const handleJSONResponse = function (response, formSelector) {
    if (response.valid) {
        if (response.redirectTo) {
            window.location.replace(response.redirectTo);
            return;
        }
        handleSuccessfullyLogin();
        return;
    }

    let form = $(formSelector);
    if (response.showLogin) {
        form = $('#dwfrm_login');
        $('[data-page-name]').remove();
        $('.js-loginwrap').show();
    } else {
        initializeInvisibleRecaptcha(form, form.find('.recaptcha-container').attr('id'));
    }

    if (response.errorHtml) {
        const existingMessage = form.find('.error-form');
        if (existingMessage.length) {
            existingMessage.remove();
        }
        form.prepend(response.errorHtml);

        existingMessage.hide().slideDown();
    }

    const button = form.find('button[type=submit]');
    button.removeClass('btn--disabled').removeClass('button-loading');
    button.find('.js-spinner-general').removeClass('spinner-visible');
};

const storeOnboardingLogin = function () {
    $('.js-onboarding-hide').each(function () {
        $(this).addClass('hide');
    });
    $('.js-onboarding-show').each(function () {
        $(this).removeClass('hide');
    });
};

const handleLoginCsrfMismatch = function () {
    const options = {
        url: Urls.getLoginPage,
        target: $('.js-loginwrap'),
        replaceTarget: true
    };
    ajax.load(options);
};

const bindHistoryHandler = function () {
    window.onpopstate = function (history) {
        if (!history.state) {
            return true;
        }

        if (history.state.showElement) {
            $(history.state.showElement).show();
        }

        if (history.state.removeElement) {
            $(history.state.removeElement).remove();
        }

        if (history.state.hideElement) {
            $(history.state.hideElement).hide();
        }

        if (history.state.formToSubmit) {
            $(history.state.formToSubmit).submit();
            history.preventDefault();
            history.stopPropagation();
            return false;
        }
    };
};

const handleSuccessfullyLogin = function (showGwpWelcomeMessage) {
    hideOverlay();

    if (showGwpWelcomeMessage && isMobile()) {
        require('./bonus-products-view').getGWPBanner();
        toaster.load({
            url: Urls.getGwpWelcomeToastMessage + '?currentPipeline=' + Urls.currentPipeline,
            close: function () {
                const isCartPage = $('.pt_cart').length > 0;
                if (isCartPage) {
                    location.reload();
                }
            }
        });
    }
};

function hideOverlay() {
    $('.js-login-overlay').animate(
        {
            bottom: '-100%'
        },
        800,
        function () {
            $(this).removeClass('overlay-visible').empty();
        }
    );
    scrollHelper.enableScroll();
}

function showResetPasswordError($response) {
    const error = $response.find('#PasswordResetForm #dwfrm_requestpassword_email-error');
    if (!error.length) {
        return false;
    }
    error.insertBefore($('#dwfrm_requestpassword_email'));
    return true;
}

function showVerificationMessage() {
    const container = $('.js-account-verification');
    if (!container.length) {
        return;
    }

    if (isMobileOrTabletWidth()) {
        toaster.init();
        toaster.def.$toastContent.html(container.html());
        toaster.open({
            close: function () {
                $('.js-modal-overlay').hide();
            }
        });
        return;
    }

    dialog.open({
        html: container.html(),
        target: $('.js-bonus-product-dialog-wrapper'),
        options: {
            width: 600,
            dialogClass: 'gwp-dialog account-verification-popup',
            open: function () {
                $('.js-modal-overlay').show();
                $(document).on('click touchstart', '.js-modal-overlay', function () {
                    dialog.close();
                });

                $(document).on('click', '.js-gwp-open .js-close-toaster', function () {
                    dialog.close();
                });
            },
            close: function () {
                dialog.close();
                $('.js-modal-overlay').hide();
                $(document).off('click', '.js-modal-overlay');
            }
        }
    });
}

function bindDynamicPasswordCheck() {
    const regex = {
        minlength: /^.{8,}$/,
        uppercase: /(?=.*[A-Z])/,
        number: /(?=.*\d)/
    };

    const $passwordInput = $('.dynamic.passwordcheck');
    const $dynamicCheckDiv = $('#dynamiccheck');

    function toggleDynamicCheckDiv() {
        if ($passwordInput.is(':focus') || $passwordInput.val() && $passwordInput.val().length > 0) {
            $dynamicCheckDiv.show();
        } else {
            $dynamicCheckDiv.hide();
        }
    }

    toggleDynamicCheckDiv();

    $passwordInput.on('focus blur', toggleDynamicCheckDiv).on('input', function () {
        const currentValue = $(this).val();

        $.each(regex, function (key, value) {
            const isValid = value.test(currentValue);
            const $target = $('#' + key);

            $target.find('span.js-icon-close').attr('hidden', isValid);
            $target.find('span.js-icon-check').attr('hidden', !isValid);
        });
    });
}

module.exports = login;
